/**
 * 職業1で「その他医療従事者」選択時に詳細プルダウンエリアを表示
 */

$(function () {
  //init
  if ($('.js-jobSelect').length) {
    if ($('.js-jobSelect option:selected').hasClass('js-jobOtherOption')) {
      $('.js-jobDetail').show()
    } else {
      $('.js-jobDetail').hide()
    }
  }

  // change
  $('.js-jobSelect').on('change', function () {
    if ($('.js-jobSelect option:selected').hasClass('js-jobOtherOption')) {
      $('.js-jobDetail').show()
    } else {
      $('.js-jobDetail').hide()
    }
  })
})
